
import ValidatableContract from '../contracts/Validatable';

/**
 * Validator class
 * @class
 */
class Validator
{
    /**
     * Validate provider resource
     * @param {ValidatableContract} resource
     * @return {Boolean}
     **/
    static validate( resource: ValidatableContract ): boolean
    {
        const errors = {},
            rules = resource.rules();

        let passes = true;
        for( const attribute in rules ) {
            let value = resource;
            const parts = attribute.split( '.' );
            for( const part of parts )
                value = value[part];

            for( const rule of rules[attribute] ) {
                const [handle, ...args] = rule.split( /[:,]/ );
                if( ! Validator[handle]( value ) ) {
                    passes = false;
                    errors[attribute] = handle;
                    break;
                }
            }
        }

        resource.errors = errors;
        return passes;
    }

    /**
     * Returns true if value has been provided, false otherwise.
     * @param {*} value
     * @return {Boolean}
     **/
    static required( value: any ): boolean
    {
        if( typeof value === 'string' )
            return value.trim() !== '';

        return value !== null && value !== undefined;
    }
}

export default Validator;
